export default [
    {
        path: '/currencies',
        name: 'PageCurrenciesList',
        meta: { title: 'currencies.listTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/currencies'),
    },
    {
        path: '/currencies/create',
        name: 'PageCurrenciesCreate',
        meta: { title: 'currencies.createFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/currencies/create'),
    },
    {
        path: '/currencies/:id/edit',
        name: 'PageCurrenciesEdit',
        meta: { title: 'currencies.editFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/currencies/id/edit'),
    },
]
